module.exports = __webpack_public_path__ + "static/visual_4_4_eg-79f0efdcc91f84b56de06b3f8d47f804.png";